// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"50f19def","453":"1358afd1","455":"ce49216c","644":"4aa5171b"}[chunkId] + ".chunk.js";
};